import Select from "react-select";
import React, { useMemo } from "react";

export const Selector = ({
  width,
  color,
  options,
  value,
  keyName,
  handleChange,
  className,
  error = false,
  helperText = "",
}) => {
  const selectProps = useMemo(() => {
    const styles = {
      control: (base, { isFocused }) => ({
        ...base,
        cursor: "pointer",
        width: width || "350px",
        height: "43px",
        border: color || "1px solid #ccc",
        borderRadius: "4px",
        padding: 0,
        display: "flex",
        alignItems: "center",
        backgroundColor: "#f8f8f8",
        "&:hover": {
          borderColor: color || "#ccc", // 保持原色
          boxShadow: "none",
          outline: "none",
        },
        ...(isFocused
          ? {
              borderColor: color || "#ccc",
              boxShadow: "none",
            }
          : {}),
      }),
      input: (base) => ({
        ...base,
        padding: 0,
        margin: 0,
        lineHeight: "43px",
        fontSize: "14px",
      }),
      menu: (base) => ({
        ...base,
        padding: 0,
        width: width || "350px",
        borderRadius: "4px",
        marginTop: "4px",
        border: "1px solid #ccc",
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
        zIndex: 600,
      }),
      menuPortal: (base) => ({ ...base, zIndex: 600 }),
      valueContainer: (base) => ({
        ...base,
        flex: 1,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        padding: "0 10px",
        display: "flex",
        alignItems: "center",
      }),
      menuList: (base) => ({
        ...base,
        maxHeight: "200px",
        overflowY: "auto",
      }),
      option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? "#e0e0e0" : "#fff",
        color: state.isSelected ? "rgb(20, 100, 200)" : "#333",
        padding: "10px",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "#d5d5d5",
        },
      }),
      singleValue: (base) => ({
        ...base,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        lineHeight: "43px",
        maxWidth: "270px",
      }),
      placeholder: (base) => ({
        ...base,
        margin: 0, // 去掉默认 margin
        display: "flex",
        alignItems: "center", // 再确保垂直居中
        height: "43px", // 和 control 同高
        lineHeight: "43px",
        overflow: "hidden", // 超出截断
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        color: "#999",
      }),
      indicatorsContainer: (base) => ({
        ...base,
        height: "43px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingRight: "8px",
      }),
    };

    return {
      styles,
      noOptionsMessage: () => "No related options",
      components: { IndicatorSeparator: () => null },
    };
  }, [width]);

  const selectedOption = useMemo(
    () =>
      options?.find((opt) => {
        const ov = opt.value;
        const vv = value;

        if (ov == null || vv == null) return false;

        // 1. 如果都是数组，就用 toString() 或者逐项比较
        if (Array.isArray(ov) && Array.isArray(vv)) {
          return ov.toString() === vv.toString();
        }
        // 2. 否则直接做严格比较（支持 string、number、boolean）
        return ov.toString() === vv.toString();
      }) || null,
    [options, value]
  );

  return (
    <div className={className}>
      <Select
        menuPortalTarget={document.body}
        menuPlacement="auto" //自動判斷空間往上或往下開
        {...selectProps}
        value={selectedOption}
        options={options}
        placeholder={null}
        onChange={(opt) => handleChange(keyName, opt.value)}
      />

      {/* helper text */}
      <div
        style={{
          minHeight: "18px", // ⭐ 防止跳動
          marginTop: "4px",
          fontSize: "12px",
          color: error ? "red" : "#666",
          visibility: helperText ? "visible" : "hidden",
        }}
      >
        {helperText || "placeholder"}
      </div>
    </div>
  );
};
